/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PropertyShortRef { 
    id?: string;
    friendly_reference?: string;
    name?: string;
    address?: string;
    /**
     * The main image of the property as saved in rentals united
     */
    image_url?: string;
    /**
     * The name of the associated building, if the property is multi unit
     */
    building_name?: string;
}

